import React, { useEffect, useState } from 'react';
import { Button, Form, Input, message } from 'antd';
import FacebookLogin from 'react-facebook-login';
import AppleSignin from 'react-apple-signin-auth';
import env from 'utils/env';
import ReCAPTCHA from 'react-google-recaptcha';
import './login.css';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { setItem } from 'utils/local-storage';
import useLoginApi from './useLoginApi';
import { Helmet } from 'react-helmet';
import { Link, useNavigate } from 'react-router-dom';
import useLoginV2 from 'hooks/useLoginV2';
import GoogleSignin from 'components/Authentication/GoogleSignin/GoogleSignin';
import { auth, googleProvider } from '../../firebase';
import { signInWithPopup, getAdditionalUserInfo } from 'firebase/auth';

const Signup: React.FC = () => {
  const { elsaIcon, captchaSiteKey, internalApiUrl } = env();
  const [signUpLoading, setSignUpLoading] = useState(false);
  const { login } = useLoginApi();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const recaptchaRef: any = React.useRef();

  const signUp = (values: any) => {
    const config = {
      headers: {
        'content-type': 'application/json'
      }
    };
    const { name, email, password } = values;
    const data = {
      username: name,
      email,
      password
    };
    setSignUpLoading(true);
    const signupURL = (document.getElementById('signup_url') as HTMLInputElement)?.value;
    axios
      .post(signupURL, data, config)
      .then((res) => {
        message.success('Your account has successfully created.');
        setSignUpLoading(false);
        navigate(`/${t('slug.login')}`);
      })
      .catch((err) => {
        message.error(err.response?.data?.message || 'There was an error! Please try again later.');
        setSignUpLoading(false);
      });
  };

  const responseFacebook = (response: any) => {
    const form = {
      facebook_token: response.accessToken
    }
    login(form);
    setItem('email-login', response.email);
  };

  const responseAppleID = (response: any) => {
    const form = {
      apple_token: response.authorization.code
    }
    login(form);
  };

  const responseGoogle = async () => {
    try {
      const result = await signInWithPopup(auth, googleProvider);
      const user = result.user;
      if (user) {
        const token = await user.getIdToken();
        const additionalUserInfo = getAdditionalUserInfo(result);
        const email = user.email || additionalUserInfo?.profile?.email;
        const form = {
          google_token: token,
          google_email: email && typeof email === 'string' ? email.toString() : ''
        }
        console.log(user, additionalUserInfo);
        login(form);
        if (email && typeof email === 'string') {
          setItem('email-login', email);
        }
      }
    } catch (error) {
      console.error('Error during Google login:', error);
    }
  };

  useLoginV2();

  const getUniversalLoginUrl = () => {
    const defaultRedirectUrl = `${window.location.origin}/user`;
    const queryParams = new URLSearchParams(window.location.search);
    const redirect = queryParams.get('redirect');
    const redirectUrl = encodeURIComponent(redirect ? defaultRedirectUrl + redirect : defaultRedirectUrl);
    return `${env().universalLoginUrl}?clientId=${env().universalLoginClientId}&redirectUrl=${redirectUrl}&lng=tw`;
  };

  return (
    <div className="signin-container">
      <Helmet>
        <title>Signup Account - ELSA Speak</title>
        <meta
          name="description"
          content="ELSA Speak App new account signup for web PC. Login my account. Redeem ELSA Premium, Oxford Business Result, ELSA for Students, free."
        />
      </Helmet>
      <div className="logo">
        <img alt="logo" src={elsaIcon} />
      </div>
      <div className="form-container">
        <h1 className="login-title">{t('signup.page_title')}</h1>

        <Button
          className="submit-button"
          onClick={() => {
            window.location.href = getUniversalLoginUrl();
          }}
        >
          {t('signup.signup')}
        </Button>

        <div className="form-login-footer">
          <span></span>
          <a href={getUniversalLoginUrl()}>
            <button className="footer-link">
              {t('login.login')}
            </button>
          </a>
        </div>
      </div>
    </div>
  );
};

export default Signup;
